module.exports = __webpack_public_path__ + "static/media/mv.ba7d31a5.webp";